export interface DailyLetterEntry {
  id: string
  order: number
  content: string
  active: boolean
}

export interface DailyLetterSelection {
  dateKey: string
  entryId: string
  content: string
}

const DATE_KEY = /^\d{4}-\d{2}-\d{2}$/

export function selectDailyLetter(dateKey: string, catalog: readonly DailyLetterEntry[]): DailyLetterSelection {
  if (!DATE_KEY.test(dateKey)) throw new Error('dateKey must use YYYY-MM-DD')
  const active = catalog.filter((entry) => entry.active).sort((a, b) => a.order - b.order || a.id.localeCompare(b.id))
  if (active.length === 0) throw new Error('Daily letter catalog has no active entries')

  const dayNumber = Math.floor(Date.parse(`${dateKey}T00:00:00Z`) / 86_400_000)
  const entry = active[((dayNumber % active.length) + active.length) % active.length]
  return { dateKey, entryId: entry.id, content: entry.content }
}

export function taipeiDateKey(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now)
}
